import { REDIRECT_URL_PARAM_AUTH } from "@/const/provider-auth.constants"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { SCM_SIGN_IN_PURPOSES } from "@/const/scm-sign-in.constants"

import type { ScmSignInPurpose } from "@/api/useScmSignIn.types"

const { POLICY_EXCEPTION, SCM_SIGN_IN, SIGN_IN } = NAMES_ROUTES

const TENANT_SLUG = /^[a-z0-9-]+$/i

export const isTenantSlug = (slug: string) => TENANT_SLUG.test(slug)

export const getSlugSignInPath = (slug: string, returnTo: string) =>
  `/${slug}/${SIGN_IN.ROOT}?${new URLSearchParams({ [REDIRECT_URL_PARAM_AUTH]: returnTo })}`

export const getPolicyExceptionPath = (scanId: string) =>
  `/${POLICY_EXCEPTION.ROOT}/${encodeURIComponent(scanId)}`

const PURPOSES: readonly string[] = Object.values(SCM_SIGN_IN_PURPOSES)

export const isScmSignInPurpose = (value: string): value is ScmSignInPurpose =>
  PURPOSES.includes(value)

// Where each sign-in purpose lands afterwards. A new purpose adds its page here.
const RETURN_PATHS: Record<ScmSignInPurpose, (purposeRef: string) => string> = {
  [SCM_SIGN_IN_PURPOSES.POLICY_EXCEPTION]: getPolicyExceptionPath
}

export const getPurposeReturnPath = (
  purpose: ScmSignInPurpose,
  purposeRef: string
) => RETURN_PATHS[purpose](purposeRef)

export const getScmReturnPath = (purpose: string, purposeRef: string) =>
  isScmSignInPurpose(purpose) ? getPurposeReturnPath(purpose, purposeRef) : null

export const getScmSignInPath = (
  purpose: ScmSignInPurpose,
  slug: string,
  purposeRef: string
) =>
  `/${SCM_SIGN_IN.ROOT}/${SCM_SIGN_IN.START}?${new URLSearchParams({ purpose, slug, purposeRef })}`

export const getKodemSignInPath = (
  slug: string,
  purpose: string,
  purposeRef: string
) => {
  const returnPath = getScmReturnPath(purpose, purposeRef)

  return isTenantSlug(slug) && returnPath
    ? getSlugSignInPath(slug, returnPath)
    : null
}
